<template>
    <div class="support-popup" id="donate-now" @click="handleOutsideClick">
        <div class="popup-container" @click.stop>
            <button class="close-button" @click="closeDialog" aria-label="Close">
                <i class="fa-solid fa-x"></i>
            </button>

            <div class="popup-content">
                <!-- Overlay with Text -->
                <div class="popup-overlay">
                    <div class="popup-text">
                        <!-- Header Section -->
                        <div class="popup-header">
                            <h1 class="popup-title">
                                We don't need everyone.<br>
                                We need 0.5% of you.
                            </h1>
                        </div>

                        <!-- Bottom Section -->
                        <div class="">
                            <p class="popup-subtitle">
                                If just <strong>half</strong> a percent of our monthly readers <br>support us with $5 on
                                Patreon,<br>
                                The Cradle can meet its goal of becoming<br>
                                <strong>fully reader-funded</strong> by 2027. Be the 0.5%.
                            </p>
                            <div style="text-align: center">
                                <button class="patreon-button" @click="f">
                                    Join us on Patreon
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DonateNowPopup",
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    },

    methods: {
        closeDialog() {
            const dialog = document.getElementById('donate-now');
            if (dialog) {
                dialog.classList.remove('active');
            }
            document.documentElement.classList.remove('filter_body');
            document.body.classList.remove('filter_body');

            this.$emit('close');
        },

        handleOutsideClick() {
            this.closeDialog();
        },

        f() {
            window.location.href = 'https://www.patreon.com/thecradlemedia/membership'
        },

        copyTRONAddressToClipboard() {
            const address = 'TEyZtrShUqFdmHYeiqYyvMc3DnYWKrcSkV';
            navigator.clipboard.writeText(address);
            alert('Address copied to clipboard!');
        },

        copyBTCAddressToClipboard() {
            const address = 'bc1qd864czk7zrrvuf5uvm0f6fecfn78mt6w8e0356';
            navigator.clipboard.writeText(address);
            alert('Address copied to clipboard!');
        },

        submitSupport(response) {
            console.log(response)
            const form = this.$refs.support;
            form.submit();
        }
    },

    mounted() {
        window.submitSupport = this.submitSupport;
    }
}
</script>

<style scoped>
.support-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
    font-size: 16px;
}

.popup-container {
    position: relative;
    max-width: 900px;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
}

.close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #a40404;
    border: none;
    color: white;
    font-size: 14px;
    cursor: pointer;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
}

.close-button:hover {
    background-color: #a01828;
}

.popup-content {
    position: relative;
    height: 550px;
    display: flex;
    flex-direction: column;
}

.popup-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(189, 0, 0, 0.89) 50%, rgba(0, 0, 0, 0.5) 50%),
    url('/assets/images/donate-popup-new.jpg');
    background-blend-mode: darken;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    padding: 40px;
}

.popup-text {
    width: 100%;
    height: 100%;
    color: white;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

/* Header Section */
.popup-header {
    flex: 0 0 auto;
    padding-top: 20px;
    line-height: 1;
}

.popup-title {
    font-size: 3em;
    font-weight: 900;
    line-height: 1;
    margin: 0;
    color: white;
}

.popup-subtitle {
    font-size: 1.6em;
    line-height: 1.5;
    color: white;
    font-weight: 400;
}

.patreon-button {
    background-color: white;
    color: #000;
    border: none;
    padding: 15px 45px;
    font-size: 1.4em;
    font-weight: bold;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: none;
}

.patreon-button:hover {
    background-color: #f0f0f0;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 255, 255, 0.3);
}


@media (max-width: 960px) {
    .popup-container {
        max-width: 100%;
        margin: 0 10px;
    }

    .popup-content {
        height: 450px;
    }

    .popup-overlay {
        padding: 30px 25px;
    }

    .popup-title {
        font-size: 2.5rem;
    }

    .popup-subtitle {
        font-size: 1.4rem;
        margin-bottom: 20px;
    }

    .popup-subtitle br {
        display: none;
    }

    .patreon-button {
        padding: 12px 35px;
        font-size: 1.3rem;
    }

    .close-button {
        width: 35px;
        height: 35px;
        top: 15px;
        right: 15px;
        font-size: 12px;
    }
}

@media (max-width: 600px) {
    .popup-title {
        font-size: 2rem;
    }

    .popup-subtitle {
        font-size: 1rem;
        margin-bottom: 12px;
    }

    .popup-overlay {
        background: linear-gradient(to top, rgba(189, 0, 0, 0.89) 50%, rgba(0, 0, 0, 0.5) 50%),
        url('/assets/images/donate-popup-new-600.jpg');
        background-blend-mode: darken;
        background-size: cover;
        background-position: center;
    }

    .patreon-button {
        padding: 12px 30px;
        font-size: 1.2rem;
    }
}

@media (max-width: 400px) {
    .popup-title {
        font-size: 1.5rem;
    }

    .popup-subtitle {
        font-size: 1rem;
        margin-bottom: 10px;
    }

    .patreon-button {
        padding: 8px 20px;
        font-size: 0.9rem;
    }
}
</style>
